import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Router } from 'react-router-dom';
import history from './history';
import routes from './routes';
// Analytics
import * as Analytics from './common/analytics';
// Components
import {
  TopLevelErrorBoundary,
} from './common';
// Helpers
import _ from 'lodash';
// Styles
import 'bootstrap/dist/css/bootstrap.css';
import 'instantsearch.css/themes/reset.css';
import JSConfetti from 'js-confetti';
import './App.css';
// Sentry
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
// Actions
import * as actions from './home/actions';
// Selectors
import AppContent from './AppContent';
import * as selectors from './home/selectors';
import { loginMfaEmailSelector, loginMfaPendingSelector } from './user/selectors';
// Assets
import Snowfall from 'react-snowfall';
import snowflakePng from '../src/common/images/snowflake.png';

const snowflake = document.createElement('img');
snowflake.src = snowflakePng;
const images = [snowflake];
const radius = [10, 15];
const speed = [2.0, 3.0];

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
  release: process.env.REACT_APP_BUILD_COMMIT,
  autoSessionTracking: false,
  integrations: [new BrowserTracing()],
  normalizeDepth: 10,
});

export const jsConfetti = new JSConfetti();

const App = ({ user, theme, fetchTheme, mfaPending, mfaEmail }) => {

  useEffect(() => {
    Analytics.setUserProperties(user);
  }, [user]);

  useEffect(() => {
    fetchTheme();
  }, [fetchTheme]);

  // Uncomment to add maintenance screen, change day and time(hour).
 //  return <MaintenanceScreen endDateDay={29} endDateTime={16}/>;

  return (
    <TopLevelErrorBoundary>
      <div>
        {theme === "christmas" && <Snowfall
          color="#BACBD9"
          snowflakeCount={80}
          images={images}
          radius={radius}
          speed={speed}
        />}
        <Router history={history}>
          <AppContent routes={routes} theme={theme} mfaPending={mfaPending} mfaEmail={mfaEmail} />
        </Router>
      </div>
    </TopLevelErrorBoundary>
  );
};

const mapStateToProps = state => {
  return {
    user: {
      id: state.user.information.id || null,
      name: `${state.user.information.firstName} ${state.user.information.lastName}`,
      email: state.user.information.email || '',
      isBusiness: !!_.find(state.user.addresses, a => a.cnpj && a.cnpj !== ''),
      createdAt: state.user.information.createdAt || '',
      userType: state.user.information.numberOfCompleteOrders > 0 ? 'existent' : 'new',
    },
    theme: selectors.themeSelector(state),
    mfaPending: loginMfaPendingSelector(state),
    mfaEmail: loginMfaEmailSelector(state),
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchTheme: () => dispatch(actions.fetchTheme()),
  };
};

const connector: Connector<{}, Props> = connect(mapStateToProps, mapDispatchToProps);

export default connector(App);
